/* global google */
import 'jquery-validation';
import AddressAutocomplete from 'google-address-autocomplete';
import {isStrongPassword, getStrongPasswordErrorMessage} from "../util/helpers";

export default {
  init: function () {

    var map;
    var locker_banks = null;

    function initializeSteps() {
      const steps = document.querySelector('.mb-schedule-pickup__steps');
      const step1 = steps.querySelector('.mb-schedule-pickup__step-1');
      const continueStep2Button = document.getElementById('mb-schedule-pickup__next-step-2');
      const continueStep2ButtonShowLoaderCssClass = 'mb-schedule-pickup__steps-next--show-loader';
      const backToStep1Button = document.getElementById('mb-schedule-pickup__steps-back-to-1');
      const schedulePickupForm = $("#schedulePickupForm");
      const showStep2CssClass = 'mb-schedule-pickup__step-2--show';

      // Validation first step fields, use jQuery selector as we use jQuery validation
      const inputAddress = $('#inputAddress');
      const inputLockerSelect = $('#inputLockerSelect');
      const inputPickupTime = $('#pickup-datetime');
      const inputDeliveryTime = $('#delivery-datetime');
      const sectionCC = $('.form_group__credit-card');
      const sectionInputLikeSelect = $('.input-like-select');

      // Set height of steps for the step1 as step2 is much higher if the user missing field, so we avoid big empty space below the step1
      // Step2 is overriding height in CSS with height auto !importan
      steps.style.height = step1.offsetHeight + 100 + 'px';

      continueStep2Button.addEventListener('click', function (event) {
        event.preventDefault();

        // We must run this here. Run the whole form validation as if we run it below, after we check the first steps individually, we have a bug for locker input not highlighted as required but just pickup date
        schedulePickupForm.valid();

        // Proceed to next step only if all required fields are ok
        if (
          ! inputAddress.valid()
          || ! inputLockerSelect.valid()
          || ! inputPickupTime.valid()
          || ! inputDeliveryTime.valid()
        ) {
          return false;
        }

        const validator = schedulePickupForm.validate();
        // Hide the error color marked fields in the second step
        validator.resetForm();
        if (sectionCC.length > 0) {
          // Manually remove the cc class error as we did custom jQuery validation error placement, and it is not removed on resetForm()
          sectionCC.removeClass('error');
          // Manually remove CC month and year erors
          sectionInputLikeSelect.removeClass('error');
        }

        continueStep2Button.classList.add(continueStep2ButtonShowLoaderCssClass);

        // Wait until we open required fields in the second step, so we can calculate the height
        setTimeout(function () {
          steps.classList.add(showStep2CssClass);
          // Important: We need to scroll to top on second step so the user see all the fields from top.
          // Before, when the user was registered, and on second step, the step was positioning on cc and hiding phone, so the user haven't filled the phone field
          setTimeout(function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }, 500)
          continueStep2Button.classList.remove(continueStep2ButtonShowLoaderCssClass);
        }, 1000)
      });

      backToStep1Button.addEventListener('click', function (event) {
        event.preventDefault();

        steps.classList.remove(showStep2CssClass);
      });
    }

    function handleLocationError(browserHasGeolocation, map) {

      const infoWindow = new google.maps.InfoWindow({map: map});
      infoWindow.setPosition(map.getCenter());
      var message = '';
      if (browserHasGeolocation) {
        message = "You did not share your location. Please activate it in your browser for a better user experience";
      } else {
        message = "Error: Your browser doesn't support geolocation.";
      }
      infoWindow.setContent(message);
      blockLockerBankInput();
    }

      /**
       * Blocks Locker bank input, make it not clickable and Add No lockers near your location message.
       */
    function blockLockerBankInput() {
        // If no locker banks, make it not clickable.
        $('#locker_bank_p').html('No lockers near your location');
        $('#inputLockerBank option[value=\'-1\']').remove();

        // We need extra space for this one.
        $('#locker_bank_p').removeClass('col-6').addClass('col-12');
        $('#inputLockerBank').attr("disabled", true);
    }

    function initMap() {

      const mapWrapper = document.getElementById("current_location");
      mapWrapper.classList.add('mb-schedule-pickup__map--show');
      map = new google.maps.Map(mapWrapper, {
        center: {lat: 44.968032, lng: -93.259883},
        zoom: 6,
      });

      /**var timeout;
       google.maps.event.addListener(map, 'bounds_changed', function () {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
              var lat = map.getCenter().lat();
              var lng = map.getCenter().lng();
                var pos = {
                    lat: lat,
                    lng: lng,
                };
              getLockersBank(lat, lng, map);
              map.panTo(pos);
            }, 900);
        }); //time in ms, that will reset if next 'bounds_changed' call is send, otherwise code will be executed after that time is up**/
    }

    // Move lockers loading on click as the request takes too long and it is blocking all ajax calls until it is done
    $('#mb-schedule-locker-banks__load-lockers-on-click').on('click', function (event) {
      event.preventDefault();

      initMap();

      event.currentTarget.remove();

      $('#spinning-overlay').css('display', 'flex');

      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          getLockersBank(pos, map);

        }, function () {
          // Get Recent Locker history from user
          getRecentLockerStoryFromUser(map, true);
        });
      } else {
        // Browser doesn't support Geolocation
        getRecentLockerStoryFromUser(map, false);
      }

    })

    initializeSteps();

    function getRecentLockerStoryFromUser(map, browserHasGeolocation) {
        $.ajax({
            // eslint-disable-next-line no-undef
            url: ajax_vars.ajax_url,
            type: 'GET',
            dataType: 'json',
            // eslint-disable-next-line no-undef
            data: {action: 'get_locker_banks_history', 'security': ajax_vars.ajax_nonce},
            success: function (response) {
                if ( response.data.length > 0 ) {
                    locker_banks = response.data;
                    addMarkersToMap(response, map);
                    setLockerBankInput(response.data);
                } else {
                    handleLocationError(browserHasGeolocation, map);
                }
                $('#spinning-overlay').hide();
            },
        });
    }

    // Get all the markers for lat, long
    function getLockersBank(pos, map) {
        // Get Locker stores around my lat,long
        $.ajax({
            // eslint-disable-next-line no-undef
            url: ajax_vars.ajax_url,
            type: 'GET',
            dataType: 'json',
            // eslint-disable-next-line no-undef
            data: {action: 'get_locker_banks', 'security': ajax_vars.ajax_nonce, lat: pos.lat, lng: pos.lng},
            success: function (response) {
                locker_banks = response.data;
                addMarkersToMap(response, map, pos);
                setLockerBankInput(response.data);
                $('#spinning-overlay').hide();
            },
        });
    }

    // Adds all markers to the map
    function addMarkersToMap(info, map, pos = null){

      var locations = info.markers;
      var markers = new Array();
      var infowindow = new google.maps.InfoWindow({
          maxWidth: 160,
      });

        var icons = {
            public: {
                name: "Public Lockers",
                icon: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
            },
            private: {
                name: "Private Lockers",
                icon: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
            },
            info: {
                name: "24/7 Lockers",
                icon: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
            },
        };

      // Add the markers and infowindows to the map
      for (var i = 0; i < locations.length; i++) {

          var icon_url = '';
          switch ( info.data[i].PickupInstructions.toLowerCase() ) {
              case 'private':
                  icon_url = icons.private.icon;
                  break;
              case 'public':
                  icon_url = icons.public.icon;
                  break;
              case '24/7':
                  icon_url = icons.info.icon;
                  break;
              default:
                  //We use Public ones, to prevent lockers not set.
                  icon_url = icons.public.icon;
          }

          var marker = new google.maps.Marker({
              position: new google.maps.LatLng(locations[i][1], locations[i][2]),
              title: locations[i][0],
              map: map,
              icon: icon_url,
          });

          markers.push(marker);

          google.maps.event.addListener(marker, 'click', (function(marker, i) {
              return function() {
                  infowindow.setContent(locations[i][0]);
                  infowindow.open(map, marker);
                  setChoosenLocationForm(i);
              }
          })(marker, i));
      }

        // Adding Legend to the canvas map. Just first time.
        // If user search for new locations, we don't need to create the legend again.
        var legend = document.getElementById('legend');
        if ( 1 === legend.childElementCount ) {
            for (var key in icons) {
                var type = icons[key];
                var name = type.name;
                var icon = type.icon;
                var div = document.createElement('div');
                div.innerHTML = '<img class="icons" src="' + icon + '"> ' + name;
                legend.appendChild(div);
            }
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(legend);
            legend.style.display = "block";
        }

      // If positions is defined, we add own marker and set the center and zoom
      if (pos) {
          // Adding user position
          var client_position = new google.maps.Marker({
              position: pos,
              title: "Your location",
              map: map,
          });

          markers.push(client_position);
          map.setCenter(pos);
          map.setZoom(15);
      } else {
          // Autocenter with given markers
          //  Create a new viewpoint bound
          var bounds = new google.maps.LatLngBounds();
          //  Go through each...
          for (var j = 0; j < markers.length; j++) {
            bounds.extend(markers[j].position);
          }
          //  Fit these bounds to the map
          map.fitBounds(bounds);
      }

    }

    // Once a user selects a Marker, we need to fill all the data in the form.
    function setChoosenLocationForm(index) {
      var address = locker_banks[index].Address.Address1;
      var city = locker_banks[index].Address.City;
      var zip = locker_banks[index].Address.Zip;

      $('#inputAddress').text(address + ', ' + city);
      $('#inputAddress').attr('value', address + ', ' + city);
      $("input[name*='address1']").attr('value', address + ', ' + city);

      $('#inputZipCode').text(zip);
      $('#inputZipCode').attr('value', zip);
      $("input[name*='sch_zipcode']").attr('value', zip);

      $('#inputLockerBank').val(index);
      $('#inputLockerBank').css('opacity', 1);
      setLockersInput(index);
    }

      /**
       * Setting Locker Banks options on the input.
       * @param locker_banks
       */
    function setLockerBankInput(locker_banks) {
          if (locker_banks.length === 0) {
              blockLockerBankInput();
              return;
          } else {
              // If it was blocked before, we need to make changes accordingly to make it functional again.
              if ( 'No lockers near your location' === $('#locker_bank_p').html() ) {
                  $('#locker_bank_p').html('Locker Location');
                  // We revert back the extra space and enable back the input locker select
                  $('#locker_bank_p').removeClass('col-12').addClass('col-6');
                  $('#inputLockerBank').attr("disabled", false);
              }
          }

        for (var i = 0; i < locker_banks.length; i++) {
            $('#inputLockerBank').append('<option value="' + i +'">' + locker_banks[i].LocalNodeKey +'</option>');
        }
    }

    /**
     * Setting Locker Bank numbers on input.
     * @param locker_index
     */
    function setLockersInput(locker_index) {
      var lockers = locker_banks[locker_index].Lockers;

      $('.inputLockerFormLabel').addClass('d-none');
      $('.inputLockerSelectLabel').removeClass('d-none');

      var lockers_available = 0;
      // Clean all previous values.
      $('#inputLockerSelect').empty();

      for (var i = 0; i < lockers.length; i++) {

          if ( i == 0 ) {
              $('#inputLockerSelect').append('<option value="">Select</option>');
          }

          // Avoid occupied lockers
          if (lockers[i].Occupied) {
            continue;
          }

          $('#inputLockerSelect').append('<option value="' + lockers[i].ID +'">' + lockers[i].LocalNodeKey +'</option>');
          lockers_available++;
      }

      if (lockers_available == 0) {
          $('#inputLockerSelect').append('<option value="-1">Sorry, all lockers occupied.</option>');
      } else {
          // Assign to locker, first option of the select, since is autoselected but not detected on on change
          // This way we can trigger handleLockerInput
          // Exact action than $(document).on('change', '#inputLockerSelect', function()
          //var first_select_value = $("#inputLockerSelect option:eq(0)").text();
          //$('#inputLocker').val(first_select_value);
          //$('#inputLockerSelect').css('opacity', 1);
          //handleLockerInput();
      }
    }

    $(document).on('change', '#inputLockerBank', function() {

        var locker_selected = this.value;
        if (locker_selected == -1) {
            $('#inputLockerBank').css('opacity', 0.5);
            $('.inputLockerSelectLabel').addClass('d-none');
            $('.inputLockerFormLabel').removeClass('d-none');
            // Reset Locker# and pickup date and time (if filled already)
            resetFields();
            return;
        }
        $('#lockerScheduleModal').modal('show');
    });

    $(document).on('change', '#inputLockerSelect', function() {
        var locker_number_selected = this.value;
        if (locker_number_selected == '') {
            $('#inputLockerSelect').css('opacity', 0.5);
            // Reset Locker# and pickup date and time (if filled already)
            resetFields();
            return;
        }
        locker_number_selected = $("#inputLockerSelect option:selected").text();
        // Assign to locker input number
        $('#inputLocker').val(locker_number_selected);
        $('#inputLockerSelect').css('opacity', 1);
        handleLockerInput();
    });

    // We leave here all the setup for requested_services as required input, as it is not required anymore, but if we need to make it required again.
    // A lot of effort was spent on making it required so I don't what to delete it.
    const requestedServicesRequiredInput = $('.form_group__requested_services input:required');
    if (requestedServicesRequiredInput) {
      requestedServicesRequiredInput.on('change', function() {
        var requstedServicesSection = $('.form_group__requested_services');
        var checkboxes = requstedServicesSection.find('input');
        var checked = false;
        checkboxes.each(function (index, checkbox) {
          if (checkbox.checked) {
            checked = true;
          }
        });

        if (checked) {
          requstedServicesSection.removeClass('error');
        } else {
          requstedServicesSection.addClass('error');
        }
      });
    }

    function debounce(fn, delay) {
      var timer = null;
      return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    }

    // Just run valid() on phone, password and name inputs so the jQuery validation will auto remove the field error appearance
    $('#phone').on('input', debounce(function () {
      $(this).valid();
    }, 600));

    $('#inputPassword').on('input', debounce(function () {
      $(this).valid();
    }, 600));

    $('#inputFullName').on('input', debounce(function () {
      $(this).valid();
    }, 600));

    // Toggle password type to view password
    const inputPassword = $('.mb-schedule-pickup__password input');
    $('.mb-schedule-pickup__eye').click(function () {
      if (inputPassword.attr('type') === 'text') {
        inputPassword.attr('type', 'password');
      } else {
        inputPassword.attr('type', 'text');
      }
    });

    function creditCardValid() {
      var creditCardSection = $('.form_group__credit-card');
      var selectFields = creditCardSection.find('select');
      var inputField = creditCardSection.find('input');

      if (selectFields.valid() && inputField.valid()) {
        creditCardSection.removeClass('error');
        var ccLast4Digits = '**** **** **** ' + inputField.val().slice(-4);
        var ccExpMonth = creditCardSection.find('#inputCardExpMonth').val();
        var ccExpYear = creditCardSection.find('#inputCardExpYear').val();
        creditCardSection.find('.form_group__credit-card-details').text(ccLast4Digits + ', ' + ccExpMonth + '/' + ccExpYear);
      } else {
        creditCardSection.addClass('error');
      }
    }
    $('.form_group__credit-card select').on('change', function () {
      creditCardValid();
    });

    $('.form_group__credit-card input').on('input', function () {
      creditCardValid();
    });

    // pickup and delivery other custom instructions error handling
    const inputPickupDeliveryOtherCustomInstructions = $('.form_group__pickup-delivery-instructions input[type="text"]');
    inputPickupDeliveryOtherCustomInstructions.on('input', debounce(function () {
      var that = $(this);
      var section = that.parents('.form_group__pickup-delivery-instructions');

      if (that.valid()) {
        section.removeClass('error');
      } else {
        section.addClass('error');
      }
    }, 600));

    const otherDeliveryPickupCustomInstructionsDiv = $('.form_group__pickup-delivery-instructions-other');
    const otherDeliveryPickupCustomInstructionsInput = otherDeliveryPickupCustomInstructionsDiv.find('input');
    const radioButtonsPickupAndDeliveryInstructions = $('.form_group__pickup-delivery-instructions input[type="radio"]');
    const otherDeliveryPickupCustomInstructionsDivShowClass = 'form_group__pickup-delivery-instructions-other--show';
    const pickupAndDeliveryInstructionsSection = $('.form_group__pickup-delivery-instructions');

    radioButtonsPickupAndDeliveryInstructions.on('change', function () {
      const that = $(this);
      const value = that.val();


      if (value === 'other') {
        otherDeliveryPickupCustomInstructionsDiv.addClass(otherDeliveryPickupCustomInstructionsDivShowClass);
        otherDeliveryPickupCustomInstructionsInput.focus();
        pickupAndDeliveryInstructionsSection.addClass('error');
      } else {
        otherDeliveryPickupCustomInstructionsDiv.removeClass(otherDeliveryPickupCustomInstructionsDivShowClass);
        pickupAndDeliveryInstructionsSection.removeClass('error');
      }
    });

    // Clear radio button selection for pickup and delivery instructions
    $('.form_group__pickup-delivery-instructions-clear-all a').on('click', function (event) {
      event.preventDefault();
      radioButtonsPickupAndDeliveryInstructions.prop('checked', false);
      otherDeliveryPickupCustomInstructionsDiv.removeClass(otherDeliveryPickupCustomInstructionsDivShowClass);
      pickupAndDeliveryInstructionsSection.removeClass('error');
    });

    $("#free-items").tooltip();

    function validateSchedulePickupForm() {
      $.validator.addMethod("autoaddress", function () {
        if ($( "input[name*='address1']").val().length == 0 ||
          $( "input[name*='city']").val().length == 0 ||
          $( "input[name*='state']").val().length == 0) {
          return false;
        }
        return true;
      }, "Re-enter and select address from the dropdown.");

      $.validator.addMethod("fullNameNeedTwoStrings", function(value) {
        return value.split(' ').filter((word) => word.length > 0).length >= 2;
      }, "Please add both first and last names with the space between.");

      $.validator.addMethod("passwordCustomRules", function(value) {
        return isStrongPassword(value);
      }, getStrongPasswordErrorMessage);

      $.validator.addMethod("pickupDeliveryInstructionsOther", function(value) {
        const radioButtonsCheckedVal = $('.form_group__pickup-delivery-instructions input[type="radio"]:checked').val();
        // Only if the user selected other in the radio buttons, we require this field
        if ('other' === radioButtonsCheckedVal) {
          return value.length > 0;
        }

        return true;
      }, "Please add your instructions.");

      $("#schedulePickupForm").validate({
        errorElement: "span",
        rules: {
          inputAddress : {
            autoaddress : true,
            required: true,
          },
          sch_zipcode: "required",
          ondemand_pickup: "required",
          ondemand_delivery: "required",
          // Just add required html attr to the requested_services checkbox to force the validation
          requested_services: "required",
          cardnumber: {
            creditcard: true,
            required: true,
          },
          locker_number_select: {
            required: function() {
              if ($('#inputLockerBank').val() >= 0) {
                return true;
              }
              return false;
            },
          },
          legacy_password: {
            passwordCustomRules: true,
            required: true,
          },
          phone: {
            required: true,
            phoneUS: true,
          },
          missing_full_name: {fullNameNeedTwoStrings : true},
          pickup_and_delivery_instructions_other: {pickupDeliveryInstructionsOther : true},
        },
        onkeyup: false,
        onfocusout: function (element) {
          var self = this;
          // Checking user address if it has been picked from dropdown, in that case, we pass validation again.
          if (element.name === 'inputAddress' || element.name === 'sch_zipcode') {
            // wait for google maps response
            setTimeout(function () {
              self.element(element);
            }, 600);

          } else {
            return false;
          }
        },
        errorPlacement: function (error, element) {
          var elementAttrName = element.attr("name");

          if (elementAttrName == "locker_number_select") {
            $('.inputLockerSelectLabel').addClass('error');
          }

          if (elementAttrName == "cardnumber" || elementAttrName == "exp_month" || elementAttrName == "exp_year") {
            const sectionCreditCard = element.parents('.form_group__credit-card');
            sectionCreditCard.addClass("error form_group__section--open");
          }

          if (elementAttrName == "exp_month" || elementAttrName == "exp_year") {
            if($( "span.custom" ).length) {
              $( "span.custom" ).remove();
            }

            $(".input-like-select").addClass("error");
            error.addClass("custom");
            error.insertAfter($(".input-like-select"));

          } else if (elementAttrName == "requested_services[]") {
            const checkbox = element.parents('.form_group__requested_services');
            checkbox.addClass("error form_group__section--open");
            error.insertAfter(checkbox)

          } else if (elementAttrName == "pickup_and_delivery_instructions_other") {
            const section = element.parents('.form_group__pickup-delivery-instructions');
            section.addClass("error");
            error.insertAfter(element);

          } else {
            error.insertAfter(element);
          }
        },
        showErrors: function (errors) {
          if (errors) {
            this.defaultShowErrors();
          }

          if ($("#inputCardExpMonth").hasClass("valid") && $("#inputCardExpYear").hasClass("valid")) {
            $(".input-like-select").removeClass("error");
          }
        },
      });
    }

    validateSchedulePickupForm();

    const options = {
      componentRestrictions: {country: "us"},
    };
    // Use a callback here to get the results
    new AddressAutocomplete("#inputAddress", options, (results) => {
      const addressObject = results;

      $("input[name=address1]").val(addressObject.streetNumber + " " + addressObject.streetName);
      $("input[name=city]").val(addressObject.cityName );
      $("input[name=state]").val(addressObject.stateAbbr );
      $("input[name=sch_zipcode]").val(addressObject.zipCode );

      // If the address is selected from the google map autocomplete, we reset and update lockers around too.
      resetFields();
      resetLockerLocation();
      getLockersBank(addressObject.coordinates, map);
    });

      // When user starts to type, we reset the address fields.
      $(document).on('keydown', '#inputAddress', function() {
          $("input[name=address1]").val('');
          $("input[name=city]").val('');
          $("input[name=state]").val('');
          $("input[name=sch_zipcode]").val('');
      });

    const schedule_form = $('#schedulePickupForm');
    const schedule_modal = $('#scheduleModal');
    const modal_content = schedule_modal.find('.modal-screens');
    const modal_title = schedule_modal.find('.modal-title');
    const hidden_field_ondemand_delivery_date = $('input[name="hidden_ondemand_delivery_date"]');
    const hidden_field_ondemand_delivery_time = $('input[name="hidden_ondemand_delivery_time"]');
    const field_schedule_type = $('input[name="schedule_type"]');
    const field_zip = $('input[name="sch_zipcode"]');
    const field_ondemand_pickup_date = $('#pickup-datetime');
    const field_ondemand_delivery_date = $('#delivery-datetime');
    const field_locker_number = $('#inputLocker');
    let locker_request_happening = false;
    const field_sections = document.getElementsByClassName('form_group__section');

    // Use these global variables to store selected pickup onDemand input and to store pre-rendered delivery times
    let deliveryOnDemandPickupTimeslots = null;
    let selectedOnDemandPickupTimeslot = null;

    /*
     * Locker scheduling
     * This callback fires after the user selects the locker and locker number, and then we call this function to load pickup and delivery times
     */
    let handleLockerInput = function () {

      if (locker_request_happening) {
        return;
      }

      const field_locker_number_value = field_locker_number.val();

      if (field_locker_number_value) {

        field_ondemand_pickup_date.removeClass('ajax');
        field_ondemand_delivery_date.removeClass('ajax');

        if (field_locker_number.data('ajax-loaded')) {
          return false;
        }

        locker_request_happening = true;

        // Get locker pickup and delivery times
        $.ajax({
          // eslint-disable-next-line no-undef
          url: ajax_vars.ajax_url,
          type: 'GET',
          dataType: 'json',
          // eslint-disable-next-line no-undef
          data: {action: 'locker_timetable', 'security': ajax_vars.ajax_nonce, zip: field_zip.val()},
          success: function (response) {
            if (response.success === 'user_not_logged_in') {
              window.location = location.protocol + "//" + location.host + "/login/";
              return;
            }

            if (response.success == 1) {
              field_locker_number.data('ajax-loaded', 'loaded');
              schedule_form.find('input[name="hidden_ondemand_pickup_date"]').val(response.data.pickup.value).change();
              schedule_form.find('input[name="hidden_ondemand_delivery_date"]').val(response.data.delivery.value).change();
              schedule_form.find('input[name="hidden_ondemand_pickup_time"]').val('locker_pickup').change();
              schedule_form.find('input[name="hidden_ondemand_delivery_time"]').val('locker_pickup').change();
              schedule_form.find('input[name="hidden_frontdoor_pickup"]').val('').change();
              schedule_form.find('input[name="hidden_frontdoor_delivery"]').val('').change();
              field_schedule_type.val('');

              field_ondemand_pickup_date.val(response.data.pickup.label);
              field_ondemand_delivery_date.val(response.data.delivery.label);
            } else {
              modal_title.html('Locker Pickup');
              modal_content.empty();

              if ($('body').hasClass('mobile')) { // use js to calculate window height on mobile

                schedule_modal.find('.modal-screens').css({'max-height': $(window).height() - 75 + 'px'});

              }

              modal_content.append(response.data.message);
              schedule_modal.modal('show');
            }

            locker_request_happening = false

          },
        });

      } else {

        resetFields();
      }
    }

    field_locker_number.change(handleLockerInput).blur(handleLockerInput).keyup(handleLockerInput);

    /*
     * OnDemand Pickup timeslots selection ajax call
     */
    schedule_form.on('focus', '.ajax', function () {


      var form_data = $(schedule_form).serialize() + '&request=' + $(this).data('request');
      var request_type = $(this).data('request');
      var title = $(this).data('title');

      modal_title.html(title);
      modal_content.empty();

      if ($('body').hasClass('mobile')) { // use js to calculate window height on mobile

        schedule_modal.find('.modal-screens').css({'max-height': $(window).height() - 75 + 'px'});

      }

      modal_content.append('<div class="loader text-center"><i class="fas fa-circle-notch fa-spin"></i><span>Loading available ' + request_type + ' times...</span></div>');
      schedule_modal.addClass('loading').modal('show');

      const handleTimeslotsResponse = (response) => {
        schedule_modal.removeClass('loading');

        var main_screen = $('<div class="main-screen"/>');
        var one_hour_screen = $('<div class="one-hour-windows"/>');
        var two_hour_screen = $('<div class="two-hour-windows"/>');

        if(!response.html.two_hour.has_data && response.html.one_hour.has_data) {

          modal_content.html(response.html.one_hour.html);

        } else if (response.html.two_hour.has_data && !response.html.one_hour.has_data) {

          modal_content.html(response.html.two_hour.html);

        } else  if (response.html.two_hour.has_data && response.html.one_hour.has_data) {

          one_hour_screen.hide();
          two_hour_screen.hide();
          one_hour_screen.html(response.html.one_hour.html);
          two_hour_screen.html(response.html.two_hour.html);

          modal_content.html(main_screen.html(response.html.main_screen.html));

          modal_content.append(one_hour_screen);
          modal_content.append(two_hour_screen);

        }

        modal_content.append(response.html.options.html);

        if(request_type == 'delivery') {
          modal_content.prepend('<span class="notes">* Household, leather, wedding, shoes, rug and and alterations items may require additional time</span>');

        }

        if(response.schedule_type !== undefined) {
          $('input[name="schedule_type"]').val(response.schedule_type);
        }
      };

      if(request_type == 'pickup') {
        $.ajax({
          // eslint-disable-next-line no-undef
          url: ajax_vars.ajax_url,
          type: 'GET',
          dataType: 'json',
          data: form_data,
          success: function (response) {
            if (response.success === 'user_not_logged_in') {
              window.location = location.protocol + "//" + location.host + "/login/";
              return;
            }

            // Store delivery timeslots for the next request which fires automatically and uses this same ajax again for delivery timeslots
            deliveryOnDemandPickupTimeslots = response.deliveryTimeslotsData;

            handleTimeslotsResponse(response);
          },
        });
      }

      if(request_type == 'delivery') {
        // Use pickup timeslot user selected to get which delivery times to load, before we change modal_content and load delviery timeslots to replace pickup timeslots
        handleTimeslotsResponse(deliveryOnDemandPickupTimeslots[selectedOnDemandPickupTimeslot]);

        // Reset values on every load to avoid having the wrong value in the upper scope var
        deliveryOnDemandPickupTimeslots = null;
        selectedOnDemandPickupTimeslot = null;
      }
    });


    modal_content.on('click', 'input[type="radio"]', function () {

      var field_name = $(this).attr('name');
      var field_value = $(this).val();
      var field_value_time = $(this).data('time');
      var field_value_date = $(this).data('date');
      var field_value_price = $(this).data('price');

      // Set which pickup timeslot user selected, so we can load delivery times for it
      selectedOnDemandPickupTimeslot = $(this).data('timeslot-js-id');

      // Route information (we only need it on pickups)
      if ( 'ondemand_pickup' === field_name ) {
          schedule_form.find('input[name="hidden_route_id"]').val( $(this).data('route-id') ).change();
          schedule_form.find('input[name="hidden_route_name"]').val( $(this).data('route-name') ).change();
          schedule_form.find('input[name="hidden_route_driver"]').val( $(this).data('route-driver') ).change();
      }

      schedule_form.find('input[name="hidden_' + field_name + '_date"]').val(field_value_date).change();
      schedule_form.find('input[name="hidden_' + field_name + '_time"]').val(field_value_time).change();
      schedule_form.find('input[name="' + field_name + '"]').val(field_value).change();

      if ( 'ondemand_delivery' === field_name ) {
        if (field_value_price > 0 ) {
            schedule_form.find('input[name="hidden_is_rush_order"]').val(1).change();
        } else {
            schedule_form.find('input[name="hidden_is_rush_order"]').val(0).change();
        }
      }

      if ( 'ondemand_pickup' === field_name ) {
          if (field_value_price > 0) {
              schedule_form.find('input[name="hidden_is_late_order"]').val(1).change();
          } else {
              schedule_form.find('input[name="hidden_is_late_order"]').val(0).change();
          }
      }

    });

    for (let y = 0; y < field_sections.length; y++) {
      const section = field_sections[y];
      const cssOpenClass = 'form_group__section--open';
      section.querySelector('.form_group__section-heading').addEventListener('click', function (event) {
        event.preventDefault();

        const formGroupSectionClickedEvent = new Event("formGroupSectionClicked");
        section.dispatchEvent(formGroupSectionClickedEvent);

        if (section.classList.contains(cssOpenClass)) {
          section.classList.remove(cssOpenClass);
        } else {
          section.classList.add(cssOpenClass);
        }
      });
    }

    modal_content.on('click', 'input[type="checkbox"]', function () {

      var field_name = $(this).attr('name');
      var is_checked = $(this).is(':checked') ? 1 : 0;

      schedule_form.find('input[name="hidden_' + field_name + '"]').val(is_checked).change();

    });


    //reset fields states
    field_ondemand_pickup_date.on('change', function () {

      field_ondemand_delivery_date.addClass('ajax');
      hidden_field_ondemand_delivery_date.val('');
      hidden_field_ondemand_delivery_time.val('');
      field_ondemand_delivery_date.val('');

    });

    $('body').on('click', '.delivery-complete', function (e) {

      if(!$("#schedule-options").valid()) {
        return;
      }

      e.preventDefault();

      schedule_modal.modal('hide');

    });

    // Delivery timeslots selection ajax call
    $('body').on('click', '.pickup-complete', function (e) {

      if(!$("#schedule-options").valid()) {
        return;
      }

      e.preventDefault();


      // If we clean the modal content, delivery will trigger the other path to render the modal
      // ???
      modal_content.empty();


      let selectedTime = $('input[type="radio"][name="ondemand_pickup"]:checked');
      let scheduleType = selectedTime.data('schedule-type');

      if (scheduleType == 2) { // 2 hour pickup
        field_ondemand_delivery_date.removeClass('ajax');
        let form_data = $(schedule_form).serialize() + '&request=delivery';

        $.ajax({
          // eslint-disable-next-line no-undef
          url: ajax_vars.ajax_url,
          type: 'GET',
          data: form_data,
          dataType: 'JSON',
          success: function (response) {
            hidden_field_ondemand_delivery_date.val(response.html.one_hour.data[0].value);
            hidden_field_ondemand_delivery_time.val(response.html.one_hour.data[0].times[0].value);
            field_ondemand_delivery_date.val(response.html.one_hour.data[0].label + ', ' + response.html.one_hour.data[0].times[0].label);

          },
        });

        // hide the modal
        schedule_modal.modal('hide');

      } else {
        // hide the modal
        schedule_modal.modal('hide');

        // automatically open the delivery modal
        schedule_modal.one('hidden.bs.modal', function () {

          $('input[name="ondemand_delivery"]').focus();

        });
      }

    });

    $("#schedule-options").validate({
      rules: {
        ondemand_pickup: {
          required: true,
        },
        ondemand_delivery: {
          required: true,
        },
      },
      errorPlacement: function(error) {
        if($('#ondemand_pickup-error').length > 0 || $('#ondemand_delivery-error').length > 0) {
          $('#ondemand_pickup-error').remove();
          $('#ondemand_delivery-error').remove();
        }
        $('.modal-footer').before(error);
        $(".modal-body").stop().animate({ scrollTop: 10000 }, "fast");
      },
      highlight: function() {
        return false;
      },
      unhighlight: function() {
        return false;
      },
      invalidHandler: function() {
        $('#alert-message').empty();
      },
      errorElement: "div",
      errorClass: "alert alert-danger",
      messages: {
        ondemand_pickup: 'Please select a time to continue.',
        ondemand_delivery: 'Please select a time to continue.',
      },
    });

    $('body').on('click', 'a.show-window', function () {

      var show_section = $(this).data('show');

      if(show_section == 'main-screen') {

        $('.one-hour-windows').hide();
        $('.two-hour-windows').hide();

      } else {

        $('.main-screen').hide();

      }

      $('.' + show_section).show();

    });

      // Locker confirmation modal.
      $('.submit-locker-confirmation').click(function (e) {
          e.preventDefault();

          var accept = $(this).data('accept');
          if ( accept == 'yes' ) {
              var locker_selected = $('#inputLockerBank').val();
              $('#inputLockerBank').css('opacity', 1);
              setChoosenLocationForm(locker_selected);
              $('#lockerScheduleModal').modal('hide');
              return;
          } else {
              $("#inputLockerBank option:selected").prop("selected", false);
              $("#inputLockerBank option:first").prop("selected", "selected").trigger('change');
              $('#lockerScheduleModal').modal('hide');
              return;
          }
      });

    $('#submit-schedule').click(function (e) {
      e.preventDefault();

      const submitButton = $('#submit-schedule');
      const submitButtonErrorMsg = schedule_form.find('.mb-schedule-pickup__invalid-fields-error');
      const errorsAdditionalInfo = $('.mb-schedule-pickup__invalid-fields-debug');
      errorsAdditionalInfo.html('');

      if (!schedule_form.valid()) {
        // TODO: maybe remove after debugging asana task https://app.asana.com/0/407047834434216/1204788981596353/f
        var submitValidator = schedule_form.validate();
        var invalidFieldsAsArray = submitValidator.invalid;
        var showErrorFieldsString = submitValidator.numberOfInvalids() > 0 ? 'Error fields: ' + Object.keys(invalidFieldsAsArray).join(', ') : '';
        errorsAdditionalInfo.html(showErrorFieldsString);

        if (! submitButtonErrorMsg || submitButtonErrorMsg.length < 1) {
          $('<div class="mb-schedule-pickup__invalid-fields-error">Please fill in all fields and try again.</div>').insertAfter(submitButton);
        }

        return;
      }

      submitButtonErrorMsg.remove();
      submitButton.append(' <i class="fas fa-circle-notch fa-spin fa-fw"></i>');
      submitButton.attr('disabled', true);
      schedule_form.submit();

    });
          // @TODO fix this
    // if(schedule_data.creditcard_expired == 1) {
    //
    //   modal_title.html('Update your Credit Card');
    //   modal_content.html('<p>Your credit card on file has expired or been declined. Please update your account.</p>');
    //   modal_content.append('<a href="/mypaymentinfo/" class="btn btn-custom btn-pink">Update your account</a>');
    //   schedule_modal.modal('show');
    //
    // }

    field_zip.change(function(){
      field_schedule_type.val('');
    });

    schedule_modal.on('hidden.bs.modal', function () {

      modal_title.empty();
      modal_content.empty();

    });

    function resetFields() {

      field_ondemand_pickup_date.val('');
      field_ondemand_delivery_date.val('');
      hidden_field_ondemand_delivery_date.val('');
      hidden_field_ondemand_delivery_time.val('');
      field_locker_number.val('');

      schedule_form.find('input[name="hidden_ondemand_pickup_date"]').val('');
      schedule_form.find('input[name="hidden_ondemand_delivery_date"]').val('');

      field_locker_number.removeData('ajax-loaded');
      field_ondemand_pickup_date.addClass('ajax');
      field_ondemand_delivery_date.addClass('ajax');
    }

    function resetLockerLocation() {
        $('#inputLockerBank').empty().append('<option value="-1">Select Locker Location</option>');
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/schedule-pickup.js